import { Injectable } from '@angular/core';

interface IRoutingApiConfiguration {
    baseUrl: string;
}

interface IRoutingConfiguration {
    api: IRoutingApiConfiguration;
    bidManagementUrl: string;
    signalRHubs: string;
    basePath: string;
    publicFacingUrl: string;
}

interface IPagingConfiguration {
    pageSize: number;
    maxPageLinksToDisplay: number;
    selectedPositionBase: number;
}

interface IAuthConfiguration {
    jwtAuthTokenStorageId: string;
    jwtRefreshTokenStorageId: string; 
    jwtExpiryTokenStorageId: string;
    client: string;
    secret: string;
    scope: string;
    currentUserHeaderName: string;
    nonTokenUrls: Array<string>;
}

interface IEnvironmentInfo {
    environmentName: string;
    showBanner: boolean;
}

interface ILiveChatConfiguration {
    host: string;
    channelNumber: string;
}

@Injectable()
export class Configuration {
    routing: IRoutingConfiguration = {
        api: {
            baseUrl: ''
        },
        bidManagementUrl: '',
        signalRHubs: '',
        basePath: '',
        publicFacingUrl: ''
    };
    environmentInfo: IEnvironmentInfo = {
        environmentName: '',
        showBanner: false
    };
    liveChat: ILiveChatConfiguration = {
        host: '',
        channelNumber: ''
    };
    auth: IAuthConfiguration = {
        jwtAuthTokenStorageId: 'tenders_auth_token',
        jwtRefreshTokenStorageId: 'tenders_refresh_token',
        jwtExpiryTokenStorageId: 'tenders_auth_exp',
        client: 'tenders',
        secret: 'IeC48prp',
        scope: 'ManagementPlatform.Api.Tenders offline_access',
        currentUserHeaderName: 'B2B-Current-User',
        nonTokenUrls: [
            'addressLookup',
            'registration/firstStepComplete',
            'registration/getRegistrationPageText',
            'registration/getRegistrationPageFooterText',
            'registration/furtherInformation',
            'registration/validateEmail',
            'registration/registrationComplete',
            'registration/unsubscribe',
            'tenderTeamMembers/getDetailsFromToken',
            'registration/verifyTeamMember',
            'linkaccount',
            'connect/token',
            'connect/revocation',
            'userAccounts/resetPassword',
            'userAccounts/isEmailValidated',
            'userAccounts/forgottenPassword',
            'auditLogs/userlogin',
            'categories',
            'locations'
        ]
    };
    paging: IPagingConfiguration = {
        pageSize: 25,
        maxPageLinksToDisplay: 5,
        selectedPositionBase: 2
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/configuration.ts